import { WidgetTypes } from '@mm/state/model/WidgetModel';
import { PlatformType } from '@mm/state/model/CampaignsModel';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import styles from './SmsIphonePreview.module.css';
import { TestPhoneNumberForm } from '../../../beta/modules/Settings/SMS/SMSActivationPage/TestPhoneNumberForm/TestPhoneNumberForm';
import { DialoguePreview } from '../../../../../modules/DailoguePreview/DialoguePreview';

type Props = {
  destinationPageId?: number;
  className?: string;
  campaignId?: number;
  schedulerId?: number;
  activeTestNumbers?: string[];
  onSaveCampaign?: () => void;
  schedulerIndex?: number;
  testNumber?: boolean;
  callForwarding?: boolean;
};

const modes = {
  preview: 'preview',
  numbers: 'numbers',
} as const;

type Mode = typeof modes[keyof typeof modes];

const availableWidgets = [
  WidgetTypes.QUICK_QUESTION,
  WidgetTypes.TEXT,
  WidgetTypes.IMAGE,
  WidgetTypes.GIF,
  WidgetTypes.VIDEO,
  WidgetTypes.AUDIO,
  WidgetTypes.OPT_IN,
  WidgetTypes.SMS_OPT_IN,
  WidgetTypes.SMS_OPT_IN_V2,
  WidgetTypes.SMS_OPT_IN_REPLY,
  WidgetTypes.NAVIGATE,
  WidgetTypes.FORM,
];
const smsPlatform = ['sms'];

export const SmsIphonePreview = (props: Props) => {
  const {
    destinationPageId,
    className,
    campaignId,
    schedulerId,
    activeTestNumbers,
    onSaveCampaign,
    schedulerIndex,
    testNumber = true,
    callForwarding = false,
  } = props;

  const [mode, setMode] = useState<Mode>(modes.preview);
  const [smsCount, setSmsCount] = useState(0);

  return (
    <div className={classnames(styles.preview, className)}>
      <div className={styles.previewMode}>
        <div
          className={classnames(styles.previewModeBtn, {
            [styles.previewModeBtnSelected]: mode === modes.preview,
          })}
          onClick={() => setMode(modes.preview)}
        >
          SMS Preview
        </div>
        <div
          className={classnames(styles.previewModeBtn, {
            [styles.previewModeBtnSelected]: mode === modes.numbers,
          })}
          onClick={() => setMode(modes.numbers)}
        >
          Test it
        </div>
      </div>
      {destinationPageId && (
        <div
          className={classnames(styles.previewDialogueContainer, {
            [styles.hideBlock]: mode !== modes.preview,
          })}
        >
          <DialoguePreview
            isSms
            dialogueId={destinationPageId}
            customAvailableWidgets={availableWidgets}
            setWidgetCount={setSmsCount}
            className={styles.previewDialogue}
            platforms={smsPlatform}
            sticky
          />
        </div>
      )}

      <TestPhoneNumberForm
        className={classnames(styles.testNumber, {
          [styles.hideBlock]: mode !== modes.numbers,
        })}
        edit
        test={testNumber}
        current={false}
        callForwarding={callForwarding}
        smsCount={smsCount}
        campaignId={campaignId}
        schedulerId={schedulerId}
        schedulerIndex={schedulerIndex}
        activeTestNumbers={activeTestNumbers}
        onSendTestSms={onSaveCampaign}
      />
    </div>
  );
};
